import { render, staticRenderFns } from "./StatsDetails.vue?vue&type=template&id=0c5c667c&"
import script from "./StatsDetails.vue?vue&type=script&lang=js&"
export * from "./StatsDetails.vue?vue&type=script&lang=js&"
import style0 from "./StatsDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports